import SaporeForm from "../../../forms/SaporeForm";
import OptionField from "../../../forms/fields/OptionField";

export default class ClosedMonthToExportForm extends SaporeForm {
    static newFor(monthOptions, selectedMonth, feature) {
        return new ClosedMonthToExportForm(monthOptions, selectedMonth, feature);
    }

    constructor(monthOptions, selectedMonth, feature) {
        const fields = {
            month: new OptionField(monthOptions, false, feature, selectedMonth),
        };
        super(fields, null, feature);
        this._monthOptions = monthOptions;
    }

    monthOptions() {
        return this._monthOptions;
    }

    monthField() {
        return this.getFieldByName('month');
    }

    month() {
        return this.monthField().value;
    }
}
